import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import axios from 'axios';
import { BASE_API_URL } from '../../utils/constants';
import { myFirebaseAuth } from '../../firebase/config';
import { logoutUser } from './authService';
import { CustomerCollectionViewCreate, CustomerCollectionViewUpdate } from '@dill/dill-shared';

export const getCustomerCollectionViews = createAsyncThunk(
  'customerCollectionViews/getCustomerCollectionViews',
  async ({ supplierId }: { supplierId: string }, thunkApi) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }
      const response = await axios.get<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/customerCollectionViews`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const createCustomerCollectionView = createAsyncThunk(
  'customerCollectionViews/createCustomerCollectionView',
  async (
    { supplierId, data }: { supplierId: string; data: CustomerCollectionViewCreate },
    thunkApi
  ) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }
      const response = await axios.post<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/customerCollectionViews`,
        data,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const updateCustomerCollectionView = createAsyncThunk(
  'customerCollectionViews/updateCustomerCollectionView',
  async (
    {
      supplierId,
      viewId,
      data,
    }: { supplierId: string; viewId: string; data: CustomerCollectionViewUpdate },
    thunkApi
  ) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }
      const response = await axios.put<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/customerCollectionViews/${viewId}`,
        data,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );
      return { ...response.data, viewId, data };
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const deleteCustomerCollectionView = createAsyncThunk(
  'customerCollectionViews/deleteCustomerCollectionView',
  async ({ supplierId, viewId }: { supplierId: string; viewId: string }, thunkApi) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }
      const response = await axios.delete<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/customerCollectionViews/${viewId}`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );
      return { ...response.data, viewId };
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);
